import moment from "moment";

export type DateValue = Date | moment.Moment | number | string | undefined;

const getShortDateFormat = (value) => {
  return value.replace(/Y|,$/gi, ``).trim();
};

export const formatDate = (
  value: DateValue,
  format = "YYYY-MM-DD",
  long = true
): string => {
  if (typeof value === "undefined") {
    return "";
  }

  let date;
  let year;
  if (typeof value === "number") {
    date = moment.unix(value);
    year = moment().utc().year();
  } else {
    date = moment(value);
    year = moment().year();
  }
  if (!long) {
    if (date.year() === year) {
      return date.format(getShortDateFormat(format));
    }
  }
  return date.format(format);
};
